import { ParsedPhoneNumber, parsePhoneNumber } from 'awesome-phonenumber'
import { removeExtraWhitespacesWithoutUndefined } from '../../conversion/conversionServices'

const PHONE_NUMBER_API_REGEXP = /(\+[1,9]\d{0,3}) +(\d{1,10}) +([\d][\d]{0,20}[\d])/
const PHONE_NUMBER_VALID_START_CHARS = /(^[\+0-9,0-9,\(])/
const PHONE_NUMBER_ENDS_WITH_NUMBER = /\d$/
const NO_NUMERIC_CHARS = /\D/g
const GERMAN_COUNTRY_CODE = 49
const PHONE_NUMBER_ALLOWED_CHARS = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '+',
  '-',
  '/',
  '(',
  ')',
  '.',
  ':',
  '_',
  ';',
  ',',
  '|',
  '#',
  '*',
  '{',
  '}',
  '[',
  ']',
  ' ',
]

export const isValidPhoneNumber = (value?: string) => {
  return !value || isValidPhoneNumberForRestApi(value) || isPhoneNumberOkay(value)
}

const isPhoneNumberOkay = (value: string) => {
  if (
    !isPhoneNumberBeginningWithValidCharacter(value) ||
    !isPhoneNumberEndingWithNumber(removeExtraWhitespacesWithoutUndefined(value)) ||
    !hasOnlyAllowedChars(value)
  ) {
    return false
  }
  const formattedPhoneNumber = formatPhoneNumberAsString(value)
  const parsedPhoneNumber = parsePhoneNumber(formattedPhoneNumber)
  return !isTooShortGermanNumber(parsedPhoneNumber) && parsedPhoneNumber.valid
}

const isValidPhoneNumberForRestApi = (value: string) => {
  return PHONE_NUMBER_API_REGEXP.test(value)
}

const isPhoneNumberBeginningWithValidCharacter = (value: string) => {
  return PHONE_NUMBER_VALID_START_CHARS.test(value)
}

const isPhoneNumberEndingWithNumber = (value: string) => {
  return PHONE_NUMBER_ENDS_WITH_NUMBER.test(value)
}

const hasOnlyAllowedChars = (value: string): boolean => {
  return value.split('').every((char) => PHONE_NUMBER_ALLOWED_CHARS.includes(char))
}

const isTooShortGermanNumber = (phoneNumber: ParsedPhoneNumber): boolean => {
  if (!isGerman(phoneNumber)) {
    return false
  }
  const formattedNumber = phoneNumber.number?.national
  const numberOfDigits = formattedNumber?.replaceAll(NO_NUMERIC_CHARS, '').length
  return !!numberOfDigits && numberOfDigits <= 7
}

const isGerman = (phoneNumber: ParsedPhoneNumber) => {
  return phoneNumber.countryCode == GERMAN_COUNTRY_CODE
}

const formatPhoneNumberAsString = (phoneNumber: string): string => {
  try {
    return format(parse(phoneNumber))
  } catch (e) {
    return phoneNumber
  }
}

const parse = (source: string) => {
  let formattedSource = source.replace(NO_NUMERIC_CHARS, '')
  if (source.startsWith('+')) {
    formattedSource = '+' + formattedSource
  }
  return parsePhoneNumber(formattedSource, { regionCode: 'DE' })
}

const format = (phoneNumber: ParsedPhoneNumber): string => {
  const formatted = phoneNumber.number?.international
  if (!formatted) {
    throw new Error('Phone number cannot be parsed')
  }
  return formatted?.replaceAll('/', ' ').replaceAll('-', ' ')
}
